import { render } from "./User-signature.vue?vue&type=template&id=2ac73e74"
import script from "./User-signature.vue?vue&type=script&lang=js"
export * from "./User-signature.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__